<template>
  <div class="absolute-fill d-flex justify-center align-center">
    <div
      ref="btn"
      v-bind:style="{
        transform: `scale(${blob.btn.scale || 1})`,
        opacity: isOwner && [ 'purchase', 'edit' ].includes(mode) ? null : 0
      }"
    >
      <v-btn v-blur x-large rounded height="56" min-width="56" elevation="6" dark :color="blob.btn.color || 'primary'">
        <span v-if="blob.btn.text" v-bind:class="{ 'mr-1': blob.btn.url }" v-html="blob.btn.text" />
        <v-icon v-if="!blob.btn.form" v-html="mdiOpenInNew" />
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mdiOpenInNew } from '@mdi/js';

export default {
  name: 'btn-blob',

  props: [ 'isOwner', 'mode', 'blob' ],

  created() {
    Object.assign(this, { mdiOpenInNew });
  },

  methods: {
    async adjust() {
      // We do this asynchronously to avoid interfering with updates made elsewhere
      await this.$nextTick();
      const w = this.$refs.btn.clientWidth * (this.blob.btn.scale || 1);
      if (w != this.blob.w)
        this.blob.w = w;
      const h = this.$refs.btn.clientHeight * (this.blob.btn.scale || 1);
      if (h != this.blob.h)
        this.blob.h = h;
    }
  },

  watch: {
    blob: {
      immediate: true,
      async handler() {
        await this.$nextTick();
        this.adjust();
        this.$emit('loaded');
      }
    },

    'blob.btn.scale'() {
      this.adjust();
    },

    'blob.btn.text'() {
      this.adjust();
    }
  }
}
</script>
